// src/utils/gamePersistence.js

// single source of truth for LS keys
export const LAST_LOCAL_CHANGE_KEY = "lastLocalChange";

// ---- HYDRATION GUARD (in-memory) ----
let IS_HYDRATING = false;

export function startHydration() {
  IS_HYDRATING = true;
}

export function endHydration() {
  IS_HYDRATING = false;
  // tell the app (store.js) that server snapshot is fully applied to LS
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("WTUFO_HYDRATED"));
  }
}

export function isHydrating() {
  return IS_HYDRATING;
}

/** Mark that local game state changed (for the sync orchestrator). */
export const markLocalChange = () => {
  // IMPORTANT: don't mark dirty during hydration restore
  if (IS_HYDRATING) return;
  try {
    localStorage.setItem(LAST_LOCAL_CHANGE_KEY, new Date().toISOString());
    // notify orchestrator to consider an immediate/throttled sync
    if (typeof window !== "undefined") {
      window.dispatchEvent(new Event("WTUFO_DIRTY"));
    }
  } catch {}
};

/** Convenience: set any LS item then mark change. */
export const setAndMark = (key, value) => {
  try {
    const payload = typeof value === "string" ? value : JSON.stringify(value);
    localStorage.setItem(key, payload);
  } catch {}
  markLocalChange();
};

/** Optional JSON helpers to keep things consistent
 *  pass { silent: true } when you want to avoid marking dirty explicitly
 *  (usually not needed because we skip during hydration anyway).
 */
export const saveJSON = (key, obj, { silent = false } = {}) => {
  try {
    localStorage.setItem(key, JSON.stringify(obj));
  } catch {}
  if (!silent) markLocalChange();
};

export const loadJSON = (key, fallback = null) => {
  try {
    const raw = localStorage.getItem(key);
    return raw == null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
};
